import { Autocomplete, TextField } from '@mui/material';
import { SyntheticEvent } from 'react';
import { connect } from 'react-redux';
import { CustomerType } from '../../common/PricePrgClient';
import { RootState } from '../../store';
import { getCustomers } from './redux/customerSelectors';
const mapStateToProps = (state: RootState) => ({
    customers: getCustomers(state)
});

type OwnProps = {
    selectedCustomer: number | undefined;
    onSelectCustomer: (customerId: number | null) => void;
    disabled?: boolean;
    label: string;
    showCustomerType: CustomerType | undefined;
    error?: boolean;
    helperText?: string;
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;
export const getSettingsUi = (state: RootState) => state.customers.ui;
const CustomerSelector = ({
    customers,
    selectedCustomer,
    onSelectCustomer,
    disabled,
    label,
    showCustomerType,
    error,
    helperText
}: Props) => {
    return (
        <Autocomplete
            value={selectedCustomer}
            onChange={(_: SyntheticEvent<Element, Event>, newValue: number | null) =>
                onSelectCustomer(newValue)
            }
            disabled={disabled}
            getOptionLabel={customer =>
                customer != null && customers[customer] != null
                    ? `${customers[customer!]?.customerNumber} - ${customers[customer!].name}`
                    : ''
            }
            id="customer"
            options={Object.values(customers)
                .filter(c => showCustomerType != null && c.customerType === showCustomerType)
                .map(c => c.customerId ?? null)}
            clearOnEscape
            renderInput={params => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    disabled={disabled}
                    error={!!error}
                    helperText={helperText}
                />
            )}
        />
    );
};

export default connect(mapStateToProps)(CustomerSelector);
